import React, { Component } from "react";
import CommonServices from "../../services/axioServices/apiServices/CommonServices.js";
import ItemMasterServices from "../../services/axioServices/apiServices/ItemMasterServices.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleNotch, faPen, faSpinner, faTrash } from "@fortawesome/free-solid-svg-icons";
import { CommonValidationMessages } from "../../utils/Messages.js";
import ValidationText from "../../utils/validation/ValidationText.js";
import { isValidForm } from "../../utils/validation/CommonValidator.js";
import SwalServices from "../../services/swalServices/SwalServices.js";

class DayBookMaster extends Component {
  constructor(props) {
    super(props);
    this.commonServices = new CommonServices();
    this.itemMasterServices = new ItemMasterServices();
    this.SwalServices = new SwalServices();
    this.state = {
      isGridView: true,
      _id: "",
      isEditing: false,
      isLoading: false,
      tableStatus: "",
      daybookList: [],
      totalCount: 0,
      searchByItemName: "",
      daybookDetails: {
        daybookName: "",
        acGroupCode: "",
        openBalance: 0,
        openBalanceDRCR: "",
        bookType: "",
        shortName: "",
        accountCodeName: "",
      },
      accountGroupList: [],
      typeOfBookList: [
        { bookType: "Bank Book" },
        { bookType: "Cash Book" },
        { bookType: "Purchase" },
        { bookType: "Sales" },
      ],
      openBalanceDRCR: [{ drcr: "DR" }, { drcr: "CR" }],
      validationRules: {
        daybookName: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "daybook name"
            ),
          },
        ],
        accountCodeName: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "accountCodeName"
            ),
          },
        ],
      },
      validState: {
        isValid: true,
        error: {},
      },
    };
  }

  componentDidMount() {
    this.getAllDaybooks();
  }

  getAllDaybooks = () => {
    this.setState({ tableStatus: "Loading..." })
    let request = this.state.searchByItemName
    this.commonServices.getAllDaybooks(request).then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let totalCount = response.responseData.length;
        if (response.responseData.length === 0) {
          this.setState({ tableStatus: "No Record Found" })
        } else {
          this.setState({ tableStatus: "" })
        }
        this.setState({ daybookList: response.responseData, totalCount: totalCount, }, () => {
          this.getAllAccountGroups();
        });
      } else {
        this.setState({ tableStatus: "" })
        this.getAllAccountGroups();
        this.SwalServices.Error(response.Message);
      }
    });
  };

  getAllAccountGroups = () => {
    this.commonServices.getAllAccountGroups().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        this.setState(
          { accountGroupList: response.responseData });
      } else {
        this.SwalServices.Error(response.Message);
      }
    });
  };

  closeGridView = () => {
    this.setState({ isGridView: false });
  };

  openGridView = () => {
    this.resetForm();
    this.setState({ isGridView: true, isEditing: false });
  };

  resetForm = () => {
    let validState = this.state.validState;
    validState.isValid = true;
    validState.error = {};
    let details = this.state.daybookDetails;
    details.daybookName = "";
    details.acGroupCode = "";
    details.openBalance = 0;
    details.openBalanceDRCR = "";
    details.bookType = "";
    details.shortName = "";
    details.accountCodeName = "";
    this.setState({ daybookDetails: details, _id: "", validState: validState, searchByItemName: "", tableStatus: "" },
      () => {
        this.getAllDaybooks();
      }
    );
  };

  searchByItemName = (event, name) => {
    let value = event.target.value;
    this.setState({ searchByItemName: value }, () => {
      this.getAllDaybooks(this.state.searchByItemName);
    });
  };

  getDaybookDetailsById = (daybook) => {
    let details = this.state.daybookDetails;
    details.daybookName = daybook.daybookName;
    details.acGroupCode = daybook.acGroupCode;
    details.accountCodeName = daybook.accountCodeName;
    details.openBalance = daybook.openBalance;
    details.openBalanceDRCR = daybook.openBalanceDRCR;
    details.bookType = daybook.bookType;
    details.shortName = daybook.shortName;
    this.setState({ daybookDetails: details, _id: daybook._id }, () => {
      this.setState({ isEditing: true, isGridView: false });
    });
  };

  handleChange = (event, name) => {
    let value = event.target.value;
    let details = this.state.daybookDetails;
    details[name] = value.toUpperCase();
    this.setState({ daybookDetails: details });
  };

  handleDropdownChange = (e, name) => {
    const selectedYear = e.target.value;
    let details = this.state.daybookDetails;
    details[name] = selectedYear;
    this.setState({ daybookDetails: details });

  };

  addEditDaybook = () => {
    let isValidAllFields = this.isValidAllFields();
    if (isValidAllFields) {
      this.setState({ isLoading: true }, () => {
        let request = this.state.daybookDetails;
        request.acGroupCode = this.state.accountGroupList.find(
          (x) => x.accountGroupname === request.accountCodeName
        ).accountGroupCode;
        if (this.state._id && this.state._id !== "") {
          request._id = this.state._id;
        } else {
          delete request._id;
        }
        this.itemMasterServices.addEditDaybook(request).then((response) => {
          if (response.statusCode === 200 && response.responseData != null) {
            this.setState({ isEditing: false, isGridView: true }, () => {
              this.resetForm();
              this.setState({ isLoading: false });
              this.getAllDaybooks();
            });
            this.SwalServices.Success(response.Message);
          } else {
            this.SwalServices.Error(
              response.Message
            );
            this.setState({ isLoading: false });
          }
        });
      })
    }
  };

  isValidAllFields = () => {
    const newValidState = isValidForm(
      this.state.daybookDetails,
      this.state.validationRules,
      this.state.validState
    );
    this.setState({ validState: newValidState });
    return newValidState.isValid;
  };

  deleteDaybookById = (id) => {
    this.itemMasterServices.deleteDaybookById(id).then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        this.SwalServices.Success(response.Message);
        this.resetForm();
        this.getAllDaybooks();
      } else {
        this.SwalServices.Error(
          response.Message
        );
      }
    });
  };

  render() {
    return (
      <div className="dayBookMaster-page">
        {this.state.isGridView === true ? (
          <>
            <div className="item-search !mb-2">
              <div className="item-grp">
                <div className="item-search-box w-[50%]">
                  <label>Book name</label>
                  <input
                    className="inputFocus"
                    type="text"
                    id="searchByItemName"
                    name="searchByItemName"
                    autoComplete="off"
                    value={this.state.searchByItemName}
                    onChange={(event) =>
                      this.searchByItemName(event, "searchByItemName")
                    }
                  />
                </div>
              </div>
              <button className="add-btn mt-3.5" onClick={() => this.closeGridView()}>
                Add new Item
              </button>
            </div>
            <div className="itemList-table">
              <p className="mb-[3px] text-[15px] font-medium text-[#474747]">Total Count :- {this.state.totalCount}</p>
              <div className="table-container" style={{ height: 'calc(100vh - 205px)' }}>
                <table className="itemList">
                  <thead>
                    <tr>
                      <td style={{ width: '35%' }}>Book Name</td>
                      <td style={{ width: '25%' }}>Book Type</td>
                      <td style={{ width: '25%' }}>Group Name</td>
                      <td style={{ width: '15%', textAlign: 'center' }}>Action</td>
                    </tr>
                  </thead>
                  {this.state.daybookList &&
                    this.state.daybookList.length > 0 ? (
                    this.state.daybookList.map((item, key) => (
                      <tbody key={key}>
                        <tr>
                          <td>{item.daybookName}</td>
                          <td>{item.bookType}</td>
                          <td>{item.accountCodeName}</td>
                          <td style={{ textAlign: 'center' }}>
                            <button
                              className="search-btn"
                              onClick={() => this.getDaybookDetailsById(item)}
                            >
                              <FontAwesomeIcon icon={faPen} />
                            </button>
                            <button
                              className="cancel-btn"
                              onClick={() => this.deleteDaybookById(item._id)}
                            >
                              <FontAwesomeIcon icon={faTrash} />
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    ))
                  ) : this.state.daybookList &&
                    this.state.daybookList.length === 0
                    && this.state.tableStatus !== "" ? (
                    <tr>
                      <td colSpan={4} style={{ textAlign: "center", fontSize: "16px" }}>
                        {this.state.tableStatus}
                      </td>
                    </tr>
                  ) : this.state.daybookList &&
                    this.state.daybookList.length === 0
                    && this.state.tableStatus === "" ? null : ""}
                </table>
              </div>
            </div>
          </>
        ) : null}
        <div className="item-listing">
          {this.state.isGridView === false ? (
            <div className="item-form">
              <div className="form-table">
                <div className="item-grp grid !grid-cols-2 !gap-2.5 mb-3">
                  <div className="input-grp">
                    <label>Book Name</label>
                    <input
                      className={`inputFocus ${this.state.validState?.error?.daybookName ? "errorInput" : ""}`}
                      type="text"
                      id="daybookName"
                      name="daybookName"
                      autoComplete="off"
                      value={this.state.daybookDetails.daybookName}
                      onChange={(event) =>
                        this.handleChange(event, "daybookName")
                      }
                    />
                    {/* <ValidationText
                      error={this.state.validState.error.daybookName}
                    /> */}
                  </div>
                  <div className="itemInner-grp grid !grid-cols-2 !gap-2.5">
                    <div className="input-grp">
                      <label>Group Name</label>
                      <select
                        className={` ${this.state.validState?.error?.accountCodeName ? "errorInput" : ""}`}
                        name="accountCodeName"
                        value={this.state.daybookDetails.accountCodeName}
                        onChange={(e) =>
                          this.handleDropdownChange(e, "accountCodeName")
                        }
                      >
                        <option>Select</option>
                        {this.state.accountGroupList &&
                          this.state.accountGroupList.length > 0 &&
                          this.state.accountGroupList.map((state, key) => (
                            <option>{state.accountGroupname}</option>
                          ))}
                      </select>
                    </div>
                    <div className="input-grp">
                      <label>Short Name</label>
                      <input
                        className="inputFocus"
                        type="text"
                        id="shortName"
                        name="shortName"
                        autoComplete="off"
                        value={this.state.daybookDetails.shortName}
                        onChange={(event) =>
                          this.handleChange(event, "shortName")
                        }
                      />

                    </div>
                  </div>
                </div>
                <div className="item-grp grid !grid-cols-2 !gap-2.5">
                  <div className="input-grp">
                    <label>Open Balance</label>
                    <div className="inputs">
                      <input
                        className="inputFocus"
                        type="number"
                        id="openBalance"
                        name="openBalance"
                        autoComplete="off"
                        value={this.state.daybookDetails.openBalance}
                        onChange={(event) =>
                          this.handleChange(event, "openBalance")
                        }
                      />
                      <select
                        name="openBalanceDRCR"
                        value={this.state.daybookDetails.openBalanceDRCR}
                        onChange={(e) =>
                          this.handleDropdownChange(e, "openBalanceDRCR")
                        }
                      >
                        <option>Select</option>
                        {this.state.openBalanceDRCR &&
                          this.state.openBalanceDRCR.length > 0 &&
                          this.state.openBalanceDRCR.map((state, key) => (
                            <option>{state.drcr}</option>
                          ))}
                      </select>
                    </div>

                  </div>
                  <div className="input-grp">
                    <label>Type Of Book</label>
                    <select
                      name="bookType"
                      value={this.state.daybookDetails.bookType}
                      onChange={(e) => this.handleDropdownChange(e, "bookType")}
                    >
                      <option>Select</option>
                      {this.state.typeOfBookList &&
                        this.state.typeOfBookList.length > 0 &&
                        this.state.typeOfBookList.map((state, key) => (
                          <option>{state.bookType}</option>
                        ))}
                    </select>
                  </div>
                </div>
              </div>
              <div className="btn-grp mt-3.5">
                {this.state.isEditing === true ? (
                  <button
                    className="add-btn"
                    disabled={this.state.isLoading}
                    onClick={() => this.addEditDaybook()}
                  >
                    {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Save"}
                  </button>
                ) : (
                  <button
                    className="add-btn"
                    disabled={this.state.isLoading}
                    onClick={() => this.addEditDaybook()}
                  >
                    {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Add"}
                  </button>
                )}
                <button
                  disabled={this.state.isLoading}
                  className="cancel-btn"
                  onClick={() => this.openGridView()}
                >
                  Cancel
                </button>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

export default DayBookMaster;
